import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpNewBlackjackStandUp implements ICommand
{

	public HostID : number = 0;
	public GameID : number = 0;
	public SeatNum : number = 0;
	public Reason : number = 0;
	public PlayerID : number = 0;
	public PlayerName : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.GameID = ba.readInt53();
		this.SeatNum = ba.readUint32();
		this.Reason = ba.readUint32();
		this.PlayerID = ba.readUint53();
		this.PlayerName = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint53(this.GameID);
		ba.writeUint32(this.SeatNum);
		ba.writeUint32(this.Reason);
		ba.writeUint53(this.PlayerID);
		ba.writeString(this.PlayerName);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpNewBlackjackStandUp();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'SeatNum(D)='+this.SeatNum+' ';
		str += 'Reason(D)='+this.Reason+' ';
		str += 'PlayerID(Q)='+this.PlayerID+' ';
		str += 'PlayerName(S)='+this.PlayerName+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50147;
	}

	public getCmdName() : string
	{
		return 'SpNewBlackjackStandUp';
	}

}
